import {
  baseClientSchema,
  Client
} from '@/modules/sales/clients/types/Client.ts'
import {
  Article,
  DeliveryArticle
} from '@/modules/sales/clients/types/Article.ts'
import { z } from 'zod'
import { appConfig } from '@/config/app.ts'

export const newClientDataSchema = baseClientSchema
  .omit({ clientName: true, createByName: true, credit: true })
  .merge(
    z.object({
      name: z.string(),
      lastName: z.string(),
      birthDate: z.string(),
      clientId: z.number(),
      credit: z.number(),
      clientUuid: z.string(),
      createdBy: z.string(),
      referralCode: z.string()
    })
  )
  .partial()

export type NewClientData = z.infer<typeof newClientDataSchema>

export interface ClientState {
  isLoadingClients: boolean
  clients: Client[]
  isCreateClientModalOpen: boolean
  isEditClientModalOpen: boolean
  isEditClientEmailModalOpen: boolean
  isEditClientPhoneModalOpen: boolean
  isEditClientReferralCodeModalOpen: boolean
  isCreateUserForClientModalOpen: boolean
  selectedClientId: string | null
  clientFilters: string
  isLoadingClientArticles: boolean
  clientArticles: Article[]
  newClientData: NewClientData | null
  isReassignModalOpen: boolean
  selectedClientArticleId: string | null
  selectedClientArticle: Article | null
  isChangeArticleModalOpen: boolean
  isDeliveryArticleModalOpen: boolean
  deliveryArticle: DeliveryArticle | null
  shouldOpenAssignArticleOnSelect: boolean
}

export const initialState: ClientState = {
  isLoadingClients: false,
  clients: [],
  isCreateClientModalOpen: false,
  isEditClientModalOpen: false,
  isEditClientEmailModalOpen: false,
  isEditClientPhoneModalOpen: false,
  isEditClientReferralCodeModalOpen: false,
  isCreateUserForClientModalOpen: false,
  selectedClientId: null,
  clientFilters: `?limit=${appConfig.pagination.defaultValue}`,
  isLoadingClientArticles: false,
  clientArticles: [],
  newClientData: null,
  isReassignModalOpen: false,
  selectedClientArticleId: null,
  selectedClientArticle: null,
  isChangeArticleModalOpen: false,
  isDeliveryArticleModalOpen: false,
  deliveryArticle: null,
  shouldOpenAssignArticleOnSelect: false
}
